function str(obj: unknown, key: string): string {
  if (!obj || typeof obj !== "object") return "";
  const val = (obj as Record<string, unknown>)[key];
  return typeof val === "string" ? val.trim() : "";
}

const list = (value: unknown): Record<string, unknown>[] =>
  Array.isArray(value) ? value.filter((item) => item && typeof item === "object") : [];

function formatTrustTypeLabel(raw: string): string {
  const labels: Record<string, string> = {
    REVOCABLE_LIVING: "Revocable Living",
    IRREVOCABLE: "Irrevocable",
    UNCLEAR: "Unclear",
  };
  return labels[raw] ?? raw;
}

export function extractLettersFields(
  extraction: Record<string, unknown> | null,
  documentType: string,
): Record<string, string> {
  if (!extraction) return {};

  const court = extraction.court_information as Record<string, unknown> | undefined;
  const caseInfo = extraction.case_information as Record<string, unknown> | undefined;
  const executorInfo = extraction.executor_information as Record<string, unknown> | undefined;
  const adminInfo = extraction.administrator_information as Record<string, unknown> | undefined;

  const isLOT = documentType === "letters_testamentary";
  const fiduciaryTitle = isLOT
    ? str(executorInfo, "executor_name")
      ? "Executor"
      : ""
    : str(adminInfo, "administrator_name")
      ? "Administrator"
      : "";

  const county = str(court, "county");
  const state = str(court, "state");
  const courtAddress = [county, state].filter(Boolean).join(", ");

  return {
    fiduciaryTitle,
    dateFiled: str(caseInfo, "date_filed"),
    dateIssued: str(caseInfo, "date_issued"),
    courtName: str(court, "court_name"),
    courtAddress,
    caseNumber: str(caseInfo, "case_number"),
  };
}

export function extractTrustFields(
  extraction: Record<string, unknown> | null,
): Record<string, string> {
  if (!extraction) return {};

  const info = extraction.trust_information as Record<string, unknown> | undefined;
  const trustees = list(extraction.trustees);
  const successors = list(extraction.successor_trustees);
  const actingTrustee = trustees.find((trustee) => trustee.is_primary) ?? trustees[0];
  const firstSuccessor = [...successors].sort(
    (a, b) => Number(a.order ?? Infinity) - Number(b.order ?? Infinity),
  )[0];

  return {
    trustName: str(info, "trust_name"),
    trustType: formatTrustTypeLabel(str(info, "trust_type")),
    dateSigned: str(info, "date_created"),
    actingTrustee: str(actingTrustee, "name"),
    successorTrustee: str(firstSuccessor, "name"),
  };
}
